import React from "react";

const AntiRagging = () => {
  return (
    <div className="w-full h-screen">
      <iframe
        title="Anti Ragging Document"
        src="/antiragging.pdf"
        className="w-full h-screen"
      />
    </div>
  );
};

export default AntiRagging;